const PROGRAMDETAILS_FILES = 'programdetails_files'
const ENROLLMENT_FORMS = 'enrollment_forms'
const TANDC_FORMS = 'tandc_forms'

const pdfFiles = [PROGRAMDETAILS_FILES, TANDC_FORMS]

export {
  PROGRAMDETAILS_FILES,
  ENROLLMENT_FORMS,
  TANDC_FORMS,
  pdfFiles
}